import isMobileAppRuntime from 'utils/isMobileAppRuntime';
import MobileFamilyFriendsDialog from './MobileFamilyFriendsDialog';
import * as moduleAPI from './api';

export const MODULE_KEY = 'familyAgeLanguage';

export const isEnabledForMobileRuntime = mobileModules => Boolean(
  isMobileAppRuntime()
  && mobileModules?.[MODULE_KEY] === true
);

export const isEnabledInResponse = response => Boolean(
  response?.mobileModules?.[MODULE_KEY] === true
);

export const mapSecondLanguageOptions = ({
  result,
  allLocales,
  instructionLocaleOptions,
  instructionLanguage,
}) => {
  if (!isEnabledInResponse(result)) return [];

  const localeLabels = new Map();
  [...(Array.isArray(allLocales) ? allLocales : []), ...instructionLocaleOptions]
    .forEach((locale) => {
      const code = String(locale?.code || locale?.value || '').trim().toLowerCase();
      const label = String(locale?.displayName || locale?.name || locale?.label || code).trim();
      if (code && label) localeLabels.set(code, label);
    });

  return (Array.isArray(result?.secondInstructionLanguages)
    ? result.secondInstructionLanguages
    : [])
    .map(item => ({
      value: String(item?.language || '').trim().toLowerCase(),
      label: localeLabels.get(String(item?.language || '').trim().toLowerCase())
        || String(item?.language || '').trim(),
    }))
    .filter(item => item.value && item.value !== instructionLanguage);
};

export {
  MobileFamilyFriendsDialog,
  moduleAPI,
};
